
import About from "./components/About";
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import Skills from "./components/Skills";
import Fs from "./components/Fs";
import Contact from "./components/Contact";


function App() {
  return (
    <div >
      <Navbar />
      <Home />
      <About />
      <Skills />
      <Fs />
      <Contact />
    </div>
  );
}

export default App;
